import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getBenefitSelection = ({ groupId, userId = null, planId }) =>
  call(websocketFetch, 'get_benefit_selection', {
    group_id: groupId,
    user_id: userId,
    plan_id: planId,
  });
